import bem from 'bem-cn';
import './theme.scss';

bem.setup({
  mod: '--',
  modValue: '-',
});

export * from './controls';
